export const stakingAddress = "0x313C4923DF3Ab94067980d1f472a7AF7032aaA52"; //mainnet
// export const stakingAddress = "0x9A9444D6125A3E2C0E8A4bd449E7A75a9fF34CF5"; //testnet
export const tokenAddress = "0xca7b3ba66556C4Da2E2A9AFeF9C64F909A59430a"; //mainnet
// export const tokenAddress = "0x1784a2B246d7f92A500e0dd4a999C2543b78332F"; //testnet

// export const priceAddress = "0x0A8Ca6C1eE7051875D1b2A97839EE2C70755b494";
export const defaultAddress = "0xb05d075609b6fa7efc02d179b74c9a50ec5d28f4";
export const tokenAddressAdmantium =
  "0x2f72aD04c549E1ab350e52E8437Ec795309218B3";
